import { render, staticRenderFns } from "./DownloadManagement.vue?vue&type=template&id=a4a837ce&"
import script from "./DownloadManagement.vue?vue&type=script&lang=js&"
export * from "./DownloadManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports